var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[(_vm.showAgenciaObjetivoDashboard)?_c('v-row',[_c('v-col',{staticClass:"pa-6 pb-0",attrs:{"cols":"12"}},[_c('agencia-objetivo-dashboard')],1)],1):_vm._e(),_c('gallery-menu',{attrs:{"nav":_vm.getMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }